import { confirmForgotPasswordUrl } from '../lib/paths';
import { usePostData } from '../lib/hooks/requests';

export const useConfirmForgotPassword = () => {
  return usePostData(confirmForgotPasswordUrl);
};
